export enum FileDisplayType {
  ICON = 'icon',
  THUMBNAIL = 'thumbnail',
}

export enum FileDisplaySize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MID = 'mid',
}

export type FileDisplaySizeToPixelsMapping = {
  readonly [key in FileDisplaySize]: number;
};

// IMPORTANT: The pixel values here must be kept in sync with the values in the scss file
export const FILE_DISPLAY_SIZE_TO_PIXELS_MAPPING: FileDisplaySizeToPixelsMapping =
  {
    [FileDisplaySize.XSMALL]: 32,
    [FileDisplaySize.SMALL]: 48,
    [FileDisplaySize.MID]: 72,
  };

export enum FileDisplayIconType {
  GENERIC = 'generic',
  SPECIFIC = 'specific',
}
